import React from 'react';
import PropTypes from 'prop-types';

import { FDContentContainer } from '@facet-wealth/design';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Typography from 'Components/UI/Typography';

import MetaFormInline from './MetaFormInline';

function MetaCollectionFormAccordion({
  collection,
  titleGenerator,
  AccordionProps,
  AccordionSummaryProps,
  AccordionDetailsProps,
  FormProps,
  TitleProps,
  metaOverride,
  metaOverrideSet,
}) {
  const resourceList = collection.resources().list();

  const accordions = resourceList.map((originalResource, i) => {
    const finalResource = metaOverride ? originalResource.overrideMeta(metaOverride) : originalResource;
    const title = titleGenerator(finalResource);
    return (
      // eslint-disable-next-line react/no-array-index-key
      <Accordion {...AccordionProps} key={`accordion-${finalResource.id()}-${i}`}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          {...AccordionSummaryProps}
        >
          {title && (
            <Typography
              color="primary"
              variant="h2"
              {...TitleProps}
            >
              {title}
            </Typography>)}
        </AccordionSummary>
        <AccordionDetails {...AccordionDetailsProps}>
          <MetaFormInline
            key={`${finalResource.id()}-${i}`} // eslint-disable-line react/no-array-index-key
            resource={finalResource}
            metaOverrideSet={metaOverrideSet}
            {...FormProps}
          />
        </AccordionDetails>
      </Accordion>
    );
  });

  return (
    <FDContentContainer maxWidth="xl">
      {accordions}
    </FDContentContainer>
  );
}

MetaCollectionFormAccordion.defaultProps = {
  titleGenerator: () => '',
  AccordionProps: {},
  AccordionSummaryProps: {},
  AccordionDetailsProps: {},
  FormProps: {},
  TitleProps: {},
  metaOverride: null,
  metaOverrideSet: null,
};

MetaCollectionFormAccordion.propTypes = {
  collection: PropTypes.object.isRequired,
  titleGenerator: PropTypes.func,
  AccordionProps: PropTypes.object,
  AccordionSummaryProps: PropTypes.object,
  AccordionDetailsProps: PropTypes.object,
  FormProps: PropTypes.object,
  TitleProps: PropTypes.object,
  metaOverride: PropTypes.object,
  metaOverrideSet: PropTypes.object,
};

export default MetaCollectionFormAccordion;
